import {Alert} from '@esgi/ui/alert';
import {GridBox} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const AlertHeader = styled(Alert.Header, {
	height: 64,

	'& > div': {
		gridTemplateColumns: '1fr auto',
		gap: '$4',

		'& > div': {
			display: 'grid',
			gridTemplateColumns: 'auto 1fr',
			alignItems: 'center',
			gap: '$2',
			color: '$mediumContrast',
		},
	},
});

export const ClassNameBox = styled(GridBox, {
	gap: '$1',
	alignItems: 'center',
	gridTemplateColumns: 'auto 1fr',

	'& > svg': {
		width: 24,
		height: 24,
		fill: '$highContrast',

		'& path': {
			fill: '$highContrast',
		},
	},
});
